<div class="body-content">
  <div class="extrato">
    
    <app-infinite-scroll-list [tabs]="tabs" [bottom]="bottom" [currentPage]="currentPage" [children]="extracts" (pageHitBottom)="onScroll($event)" (filterByDays)="onFilter($event)" (clickOnChild)="getDetails($event)"></app-infinite-scroll-list>
    <br>
    <br>

    <button *ngIf="viaAnteriorTag" (click)="goToLastExtract()" class="confirma">
        Buscar consumo da via anterior
    </button>

    <div class="backgroundTrasparente"></div>
  </div>
</div>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/extract/extract.component.html